import { EditCompensationData } from '@modules/EvaluationModule/interfaces/EditCompensationData';
import { createAction } from '@reduxjs/toolkit';

export const getUserCompensationData = createAction<string>('userCompensationPage/getUserCompensationData');
export const getUserCompensationRangeData = createAction<string>('userCompensationPage/getUserCompensationRangeData');
export const editCompensation = createAction<EditCompensationData>('userCompensationPage/editCompensation');
